import { apiUrl } from './apiBase.js';

export function escapeHtml(text) {
  if (text == null) return '';
  const div = document.createElement('div');
  div.textContent = String(text);
  return div.innerHTML;
}

export async function apiFetch(url, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  const target = apiUrl(url);
  const isCrossOrigin =
    /^https?:\/\//i.test(target) &&
    typeof window !== 'undefined' &&
    !target.startsWith(window.location.origin);

  return fetch(target, {
    credentials: isCrossOrigin ? 'include' : 'same-origin',
    ...options,
    headers,
  });
}

export function showToast(message, type = 'info', options = {}) {
  let container = document.getElementById('toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'toast-container';
    document.body.appendChild(container);
  }

  const { title } = options;
  const isCard = type === 'validation' || Boolean(title);
  const toast = document.createElement('div');
  toast.className = isCard ? 'toast toast--card' : `toast toast--${type}`;

  if (isCard) {
    toast.innerHTML = `
      <div class="toast-card-body">
        ${title ? `<div class="toast-card-title">${escapeHtml(title)}</div>` : ''}
        <div class="toast-card-message">${escapeHtml(message)}</div>
      </div>
    `;
  } else {
    const icons = { success: '✓', error: '✕', warning: '⚠', info: 'ℹ' };
    const icon = icons[type] || icons.info;
    toast.innerHTML = `<span class="toast-icon">${icon}</span><span class="toast-message">${escapeHtml(message)}</span>`;
  }

  container.appendChild(toast);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      toast.classList.add('toast--in');
    });
  });
  setTimeout(() => {
    toast.classList.remove('toast--in');
    toast.classList.add('toast--out');
    setTimeout(() => toast.remove(), 450);
  }, 4200);
}
